import { render } from "./Form.vue?vue&type=template&id=7c7b8a6d"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=7c7b8a6d&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__